<script>
import Layout from "../../layouts/main";
import axios from "@/axios";
import CreateZipButton from "@/components/create-zip-button";
import { b64toBlob, downloadPdf } from "@/utils";

export default {
  components: {
    Layout,
    'zip': CreateZipButton,
  },
  data() {
    return {
      disable: false,
      fields: [
        {
          key: "nombre",
          label: "Documentación vehículo",
          sortable: false,
        },
        {
          key: "descarga",
          label: "Descargar",
          sortable: false,
        },
      ],
      tableData: [],
      isBusy: true,
      buttonClicked: undefined
    };
  },
  mounted() {
    this.getDocuments();
  },
  computed: {
    patente: function(){
      return this.$store.getters["hideValue/detailPatente"];
    }    
  },
  methods:{
    getDocuments() {
      this.isBusy = true;
      axios
        .get(`GetDocumentacionVehiculoByPatente/${this.patente}`)
        .then((docs) => {
          this.tableData = Object.entries(docs.data).map((e) => ( { "nombre":e[0], "valor": e[1] } ));
          this.isBusy = false;
        })
        .catch(() => {
          this.$bvToast.toast(this.$t('NoData.error.message').toString(), {
            title: this.$t('NoData.error.title').toString(),
            variant: 'danger',
            solid: true
          });
          this.isBusy = false;
        });      
    },
    downloadDocumento(row){
      if(row.item.valor){
        this.buttonClicked = row.index;
        downloadPdf(b64toBlob(row.item.valor, "application/pdf"), `${this.patente.trim()}-${row.item.nombre}.pdf`);
        this.buttonClicked = undefined;
      }else{
        this.$bvToast.toast(this.$t("lease.pdf.error.nonFound").toString(), {
          title: this.$t("lease.pdf.error.download").toString(),
          variant: "danger",
          solid: true,
        });
        this.buttonClicked = undefined;
      }
    },
    back() {
      history.back();
    },
    checkContent(){
      let flag = false;
      this.tableData.forEach((element) => {
        if(element.valor){
          flag = true;
        }
      });
      return flag;
    }
  }
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="mb-3">
              <h4 class="card-tittle">Documentación del vehículo</h4>
              <div class="justify-content-end">
                <b-button @click="back">Volver</b-button>
                <zip v-if="checkContent()" class="spacingButton" :disabled="disable" :data="tableData" :title="'Descargar todo'"></zip>
              </div>
            </b-row>
            <b-row>
              <b-col sm="12" md="6" offset-md="6" lg="4" offset-lg="8">
                <b-form-group label="Patente" label-for="formrow-name-input">
                  <b-form-input
                    id="formrow-name-input"
                    v-model="patente"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="container">
              <b-table 
              :items="tableData" 
              :fields="fields"
              responsive="sm" 
              :busy="isBusy"
              class="text-center"
              show-empty
              >

                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(descarga)="row">
                  <div class="text-center">
                    <b-button variant="danger" @click="downloadDocumento(row)">
                      <i v-if="buttonClicked !== row.index" class="bx bx-download font-size-16 align-middle" />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                      Descargar
                    </b-button>
                  </div>
                </template>
                 <template #empty="">
                  <h5 style="text-align: center">
                    No hay datos disponibles, le agradecemos se comunique con Servicio al Cliente al correo: servicioalcliente@mitta.cl o al teléfono: 800370111. Gracias.
                  </h5>
                </template>
                <template #cell(nombre)="row">
                  <template v-if="row.item.nombre == 'permisoCirculacion'">
                    Permiso de Circulación
                  </template>
                  <template v-if="row.item.nombre == 'soap'">
                    SOAP
                  </template>
                  <template v-if="row.item.nombre != 'soap' && row.item.nombre != 'permisoCirculacion'">
                    {{row.item.nombre}}
                  </template>
                </template>

              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.spacingButton{
  margin-left: 1rem;
}
</style>
